import { render } from "./maker-form.vue?vue&type=template&id=c4ee5274&scoped=true"
import script from "./maker-form.vue?vue&type=script&lang=js"
export * from "./maker-form.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=c4ee5274&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c4ee5274"

export default script